"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const Api = require("../../Api");
const actions = require("./actions");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const fetch = (dispatch) => {
    return async () => {
        dispatch(actions.fetchRequest());
        try {
            const { data: { config } } = await Api.client.get('/config');
            dispatch(actions.fetchSuccess(config));
        }
        catch (error) {
            dispatch(actions.fetchFailure(Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.fetch = fetch;
//# sourceMappingURL=operations.js.map